import React, { FunctionComponent, Fragment } from 'react';
import { Text } from 'mdlkit';
import { NextLinkButton } from '../../shared';
import { event } from '../../../lib/analytics';
import { REGISTRATION } from '../../../constants/events';

const NoMatchFooter: FunctionComponent = () => (
  <Fragment>
    <Text mt="md" align="center" bold data-testid="noMatchErrorMsg">
      Sorry no match is found. Don&apos;t worry, we can still help.
    </Text>
    <NextLinkButton
      size="large"
      mt="md"
      href="/eligible-login"
      data-testid="continueWithoutCoverageBtn"
      onClick={() =>
        event({ action: 'click_see_a_provider', category: REGISTRATION })
      }
      data-track-event
      data-track={JSON.stringify({
        controlName: 'no-match-continue-without-coverage-button',
        controlText: 'Continue without Coverage',
      })}
    >
      Continue without Coverage
    </NextLinkButton>
  </Fragment>
);

export default NoMatchFooter;
